import React, { useEffect } from "react";
import { Box, Button, Container, Typography, Link } from "@mui/material";
import { useNav } from "../../context/NavProvider";
import ScriptLoader from "../account/ScriptLoader";
import { useAuth } from "../../context/AuthProvider";
import { useNavigate } from "react-router-dom";
import { useClient } from "../../context/ClientProvider";

function WaysToPay() {
    const { setShowFooter } = useNav();
    const { accessToken } = useAuth();
    const { useGetConfig } = useClient();
    const clientConfig = useGetConfig()?.clientConfig;
    const navigate = useNavigate();
    const waysToPayDataPerClient = clientConfig?.layout?.unauthenticatedPages.findWaysToPay;

    useEffect(() => {
        setShowFooter(true);
    }, [setShowFooter]);

    const handleNavClick = () => {
        if (!accessToken) {
            // Redirect to auth and pass the intended route
            navigate("/auth?redirectTo=/payment");
        } else {
            // User is authenticated, go directly to payment
            navigate("/payment");
        }
    };

    return (
        <>
            <ScriptLoader />
            <Container sx={{ mt: 4, mb: 7 }}>
                <Box sx={{ pb: 2 }}>

                    {waysToPayDataPerClient?.payOnlineSection?.enabled && (
                        <>
                            <Typography
                        variant='h1'
                        fontWeight='bold'
                        fontSize={32}
                      sx={{ py: 4 }}>
                      Ways to pay
                    </Typography>

                  <Typography
                      variant='h2'
                      fontWeight='bold'
                      fontSize={25}
                      sx={{ py: 1 }}>
                      Pay online
                            </Typography>

                  <Button
                      onClick={handleNavClick}
                      sx={{
                          flex: 1,
                          mt: 1,
                          mb: 3,
                          borderRadius: "0",
                          backgroundColor: "primary.dark",
                          width: { xs: "15em", lg: "20em" },
                          color: "#fff",
                          "&:hover": {
                              backgroundColor: "primary.light",
                              color: "primary.dark",
                          },
                      }}>
                      Make a payment
                            </Button>
                        </>)}
                    {waysToPayDataPerClient?.paymentTelephoneLine?.enabled && (
                        <>
                  <Typography
                      variant='h2'
                      fontWeight='bold'
                      fontSize={26}
                      sx={{ py: 2 }}>
                        Call the secure payment telephone line 
                            </Typography>

                  <Typography sx={{ pt: 1, pb: 2, mb: 3 }}>
                        Get in touch on <Link href={`tel:${waysToPayDataPerClient?.paymentTelephoneLine?.phoneNumber}`}>{waysToPayDataPerClient?.paymentTelephoneLine?.phoneNumber}</Link> to process your payment using our secure payment line.
                            </Typography>
                        </>)}
                    {waysToPayDataPerClient?.bankTransferOrStandingOrder?.enabled && (
                        <>

                            <Typography
                      variant='h2'
                      fontWeight='bold'
                      fontSize={26}
                      sx={{ py: 1 }}>
                      Bank Transfer or Standing Order
                  </Typography>
                  <Typography sx={{ pt: 1, pb: 1 }}>
                      Set up either of these ways to pay using our bank details listed
                        below. You'll need your Reference Number.
                            </Typography>
                  <Typography sx={{ py: 1 }}>
                                Account Name: <b>{waysToPayDataPerClient?.bankTransferOrStandingOrder?.accountName}</b>
                  </Typography>
                  <Typography sx={{ py: 1 }}>
                                Sort Code: <b>{waysToPayDataPerClient?.bankTransferOrStandingOrder?.sortCode}</b>
                  </Typography>
                  <Typography sx={{ py: 1 }}>
                                Account Number: <b>{waysToPayDataPerClient?.bankTransferOrStandingOrder?.accountNumber}</b>
                            </Typography>

                  <Typography sx={{ py: 1 }}>
                        Reference Number: Enter your {clientConfig?.name} Reference Number
                  </Typography>
                  <Typography sx={{ mb: 4, py: 1 }}>
                      * Please note this is unique to your account so can't be used to pay
                      other {clientConfig?.name} accounts.
                  </Typography>
                        </>
                    )}
                    {waysToPayDataPerClient?.chequeOrPostalOrder?.enabled && (
                        <>                    
                  <Typography
                      variant='h2'
                      fontWeight='bold'
                      fontSize={26}
                      sx={{ py: 1 }}>
                      Cheque or Postal Order
                  </Typography>
                  <Typography>
                        Send either a cheque or postal order (adding your full Name and Reference Number on the reverse) to:
                  </Typography>
                  <Typography sx={{ pt: 2 }}>{ }</Typography>
                            <Typography>
                                <Typography sx={{ pt: 2 }}>{waysToPayDataPerClient?.chequeOrPostalOrder.address1}</Typography>
                                <Typography sx={{ pt: 2 }}>{waysToPayDataPerClient?.chequeOrPostalOrder.address2}</Typography>
                                <Typography sx={{ pt: 2 }}>{waysToPayDataPerClient?.chequeOrPostalOrder.address3}</Typography>
                                <Typography sx={{ pt: 2 }}>{waysToPayDataPerClient?.chequeOrPostalOrder.postCode}</Typography>

                    </Typography>
                  <Typography sx={{ py: 1 }}>
                      * Please note that when submitting cheques there may be delays
                      despite all post being processed regularly.
                            </Typography>
                        </>
                    )}

              </Box>
          </Container>
      </>
  );
}

export default WaysToPay;
